module.exports = __webpack_public_path__ + "static/img/Levi-Ashcroft.d956128.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Levi-Ashcroft.jpg
// module id = 6Dhc
// module chunks = 0